import React from 'react'
import ServiceSection from '../../Components/mumbai/ServiceSection'
import ServiceNowConsultingSlider from '../../Components/mumbai/ServiceNowConsultingSlider'
import MaximizeModal from '../../Components/mumbai/MaximizeModal'
import IndustriesSliderSection from '../../Components/mumbai/IndustriesSliderSection'
import ServiceNowBannerSection from '../../Components/mumbai/ServiceNowBannerSection'
import { Helmet } from 'react-helmet-async'
import HireDeveloper from '../../Components/hire/HireDeveloper'
import HeroServiceSection from '../../Components/mumbai/HeroServiceSection'
import LocationForm from '../../Components/mumbai/LocationForm'
import WhyChoose from '../../Components/mumbai/WhyChoose'
import EngagementModels from '../../Components/hire/EngagementModels'
import ServiceNowLeadForm from '../../Components/ServiceNowLeadForm'

const wellbeingData = [
    {
        id: 1,
        title: "Comprehensive Support",
        description: "At Mobikode Bangalore, we're always here to support your business with reliable ServiceNow expertise, quick assistance, and practical solutions that keep operations running smoothly.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 2,
        title: "Industry Expertise ",
        description: "At Mobikode, we help businesses in Bangalore grow with practical digital solutions tailored for healthcare, finance, education, retail, real estate, logistics, and other fast-growing industries.",
        image: "/assets/mumbai/img2.png"
    },
    {
        id: 3,
        title: "Customized Solutions",
        description: "Every business has its own challenges and goals. At Mobikode, we build tailored digital solutions that simplify operations, improve efficiency, and support long-term business growth across Bangalore. ",
        image: "/assets/mumbai/img2.png"
    },

];

const consultingData = [
    {
        id: 1,
        title: "ServiceNow Consulting",
        desc: "Strategic platform advisory, maturity assessments, and digital roadmap formulation tailored to optimize your ServiceNow enterprise landscape.",
        link: "/service/servicenow-consulting",
    },
    {
        id: 2,
        title: "ServiceNow Implementation",
        desc: "End-to-end multi-module deployment, configuration, and workflow automation executed with best practices for swift enterprise adoption.",
        link: "/service/servicenow-implementation",
    },
    {
        id: 3,
        title: "ServiceNow ITSM",
        desc: "Modernize service desk operations, incident triage, change management, and request fulfillment through intelligent IT service management.",
        link: "/service/servicenow-itsm",
    },
    {
        id: 4,
        title: "ServiceNow ITOM & CMDB",
        desc: "Gain real-time infrastructure visibility, build an accurate healthy CMDB, and automate event remediation with predictive discovery.",
        link: "/service/servicenow-itom-cmdb",
    },
    {
        id: 5,
        title: "ServiceNow CSM",
        desc: "Deliver connected customer experiences by breaking down silos across front, middle, and back-office teams with proactive issue resolution.",
        link: "/service/servicenow-csm",
    },
    {
        id: 6,
        title: "ServiceNow HRSD",
        desc: "Elevate employee experiences with streamlined onboarding, unified life-event journeys, and self-service HR service delivery portals.",
        link: "/service/servicenow-hrsd",
    },
    {
        id: 7,
        title: "ServiceNow AI & Automation",
        desc: "Leverage Generative AI, Now Assist, machine learning models, and virtual agents to automate complex multi-departmental workflows.",
        link: "/service/servicenow-ai-automation",
    },
    {
        id: 8,
        title: "ServiceNow Integration",
        desc: "Seamlessly integrate your ServiceNow instance with ERPs, CRMs, cloud platforms, and legacy systems via Integration Hub and custom APIs.",
        link: "/service/servicenow-integration",
    },
    {
        id: 9,
        title: "ServiceNow Custom Development",
        desc: "Build scalable, tailor-made applications and intuitive enterprise service portals using ServiceNow App Engine and UI Builder.",
        link: "/service/servicenow-custom-development",
    },
    {
        id: 10,
        title: "ServiceNow Managed Services",
        desc: "Continuous proactive support, performance monitoring, release upgrades, technical debt reduction, and platform governance.",
        link: "/service/servicenow-managed-services",
    },
    {
        id: 11,
        title: "ServiceNow Resource Augmentation",
        desc: "Scale your delivery bandwidth with certified ServiceNow architects, developers, technical consultants, and flexible dedicated pods.",
        link: "/service/servicenow-resource-augmentation",
    },
    {
        id: 12,
        title: "ServiceNow Center of Excellence (COE)",
        desc: "Build a scalable ServiceNow ecosystem with strong governance, platform standardization, continuous improvement, and enterprise-wide innovation.",
        link: "/service/servicenow-coe",
    },
];

const industriesData = [
    {
        id: 1,
        title: "Financial Services",
        desc: "At Mobikode, we help businesses in Bangalore work smarter with secure, reliable technology that simplifies daily operations, improves customer experiences, and supports long-term business growth. ",
        image: "/assets/mumbai/item1.png"
    },
    {
        id: 2,
        title: "eCommerce ",
        desc: "At Mobikode, we help businesses in Bangalore simplify their digital journey with practical solutions that improve customer experiences, support everyday operations, and drive sustainable business growth. ",
        image: "/assets/mumbai/item2.png"
    },
    {
        id: 3,
        title: "Insurance ",
        desc: "Helping Bangalore businesses simplify everyday operations, improve customer experiences, automate workflows, and achieve sustainable growth with secure, reliable, and people-focused ServiceNow solutions from Mobikode. ",
        image: "/assets/mumbai/item3.png"
    },
    {
        id: 4,
        title: "Manufacturing",
        desc: "At Mobikode, we help businesses in Bangalore work smarter with technology, simplify everyday operations, improve productivity, and build efficient processes that support long-term growth. ",
        image: "/assets/mumbai/item4.png"
    },
    {
        id: 5,
        title: "Retail & Consumer Goods",
        desc: "At Mobikode Bangalore, we help retail and consumer brands deliver better customer experiences, simplify daily operations, and embrace digital solutions that support long-term business growth. ",
        image: "/assets/mumbai/item5.png"
    },
    {
        id: 6,
        title: "Healthcare & Life Sciences",
        desc: "At Mobikode, we help Healthcare and Life Sciences organizations in Bangalore adopt smart digital solutions that simplify operations, enhance patient care, improve collaboration, and support better healthcare outcomes.",
        image: "/assets/mumbai/item6.png"
    },
    {
        id: 7,
        title: "Media & Communications ",
        desc: "Mobikode helps media and communication businesses in Bangalore deliver engaging digital experiences, connect with audiences, simplify operations, strengthen brand relationships, and drive long-term business growth. ",
        image: "/assets/mumbai/item7.png"
    },
    {
        id: 8,
        title: "Logistics & Transportation ",
        desc: "At Mobikode, we help logistics and transportation businesses in Bangalore simplify operations, improve delivery efficiency, and deliver better customer experiences with practical digital solutions built for sustainable growth. ",
        image: "/assets/mumbai/item8.png"
    },
    {
        id: 9,
        title: "Technology",
        desc: "At Mobikode, we help businesses in Bangalore turn ideas into practical digital solutions with the right technology, expert guidance, and innovation that supports long-term growth. ",
        image: "/assets/mumbai/item9.png"
    },
    {
        id: 10,
        title: "Non Profit",
        desc: "At Mobikode, we support non-profit organizations in Bangalore with simple, effective technology solutions that help them reach more people, work smarter, and create a meaningful impact in communities. ",
        image: "/assets/mumbai/item10.png"
    },
    {
        id: 11,
        title: "Professional Services ",
        desc: "At Mobikode, we help businesses in Bangalore simplify their processes, work smarter with the right technology, and create meaningful client experiences through tailored digital solutions. ",
        image: "/assets/mumbai/item11.png"
    },
    {
        id: 12,
        title: "Real Estate ",
        desc: "At Mobikode, we help Bangalore’s real estate businesses work smarter with digital solutions that simplify operations, improve customer journeys, and create meaningful connections between builders, agents, and buyers.  ",
        image: "/assets/mumbai/item12.png"
    },

];

function Bangalore() {
    return (
        <div>
            <Helmet>
                <title>
                    ServiceNow Consulting in Bangalore | ITSM & Cloud Operations | Mobikode
                </title>

                <meta
                    name="description"
                    content="Mobikode provides ServiceNow consulting in Bangalore to modernize IT service management, automate cloud and business workflows, integrate enterprise platforms, and improve operational performance."
                />

                <meta
                    name="keywords"
                    content="ServiceNow Consulting Bangalore, ServiceNow Consultant Bangalore, ServiceNow ITSM Bangalore, ServiceNow Cloud Operations Bangalore, ServiceNow Workflow Automation Bangalore, ServiceNow Enterprise Integration Bangalore, ServiceNow Implementation Bangalore, ServiceNow Integration Bangalore, ServiceNow Managed Services Bangalore, ServiceNow Digital Transformation Bangalore"
                />

                <link
                    rel="canonical"
                    href="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-bangalore"
                />

                <meta
                    property="og:title"
                    content="ServiceNow Consulting in Bangalore | ITSM & Cloud Operations | Mobikode"
                />

                <meta
                    property="og:description"
                    content="Enhance IT operations with Mobikode's ServiceNow consulting services in Bangalore. Optimize ITSM, automate workflows, integrate enterprise and cloud platforms, and build efficient digital operations."
                />

                <meta
                    property="og:url"
                    content="https://www.mobikode.com/location/leverage-serviceNow-consulting-in-bangalore"
                />

                <meta
                    property="og:type"
                    content="website"
                />

                <meta
                    property="og:image"
                    content="https://www.mobikode.com/assets/bangalore/bg1.png"
                />

                <meta
                    name="twitter:card"
                    content="summary_large_image"
                />

                <meta
                    name="twitter:title"
                    content="ServiceNow Consulting in Bangalore | Mobikode"
                />

                <meta
                    name="twitter:description"
                    content="Explore ServiceNow solutions in Bangalore for ITSM, cloud operations, workflow automation, enterprise integration, and digital transformation with Mobikode."
                />

                <meta
                    name="twitter:image"
                    content="https://www.mobikode.com/assets/bangalore/bg1.png"
                />
            </Helmet>
            <HeroServiceSection bgImage="/assets/mumbai/bg1.png" title="Leverage ServiceNow Consulting in Bangalore" description="Partner with Mobikode’s ServiceNow experts in Bangalore to simplify daily operations, empower your teams, automate business processes, and achieve sustainable growth through intelligent digital transformation. Trusted by Startups and Leading Companies Worldwide" />
            <ServiceNowLeadForm bgImage="/assets/mumbai/banglore.png" />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <WhyChoose />
            <MaximizeModal wellbeingData={wellbeingData} />
            <EngagementModels />
            <IndustriesSliderSection industriesData={industriesData} />
            {/* <section className="relative w-full h-[500px] lg:h-[630px] flex items-center bg-[#000814] overflow-hidden py-12 md:py-0">
                <div className="absolute inset-0 z-0">
                    <img
                        src="/assets/mumbai/bg1.png"
                        alt="Abstract 3D Background"
                        className="w-full h-full object-cover"
                    />
                    <div
                        style={{ background: "linear-gradient(86.84deg, #000000 20%, rgba(0, 0, 0, 0) 79%)" }}
                        className="hidden md:block absolute inset-0"
                    ></div>
                    <div
                        style={{ background: "linear-gradient(0deg, #000000 40%, rgba(0, 0, 0, 0.3) 100%)" }}
                        className="block md:hidden absolute inset-0"
                    ></div>
                </div>

                <div className="relative z-10 w-full max-w-[1440px] mx-auto px-[20px] md:px-[40px] lg:px-[80px] flex flex-col items-start justify-center h-full">
                    <div className="w-full max-w-[500px] md:max-w-[700px] lg:max-w-[900px] mt-auto md:mt-0">
                        <h1 className="text-white font-[600] text-[28px] sm:text-[36px] md:text-[50px] lg:text-[60px] font-sora leading-[1.2] lg:leading-[1.1] mb-[12px] lg:mb-[22px] drop-shadow-xl tracking-wide text-left">
                            Leverage ServiceNow Consulting in Bangalore
                        </h1>
                        <p className="text-[#FFFFFF] max-w-[800px] w-full text-[14px] sm:text-[16px] md:text-[18px] leading-[20px] md:leading-[22px] lg:leading-[24px] font-graphik font-light tracking-wider text-left opacity-90 lg:opacity-100">
                            Partner with Mobikode’s ServiceNow experts in Bangalore to simplify everyday operations, empower your teams, automate time-consuming workflows, and create smarter solutions that help your business grow with confidence.
                        </p>
                    </div>
                </div>
            </section>
            <ServiceSection image={"/assets/mumbai/banglore.png"} text={"At Mobikode, we help businesses in Bangalore make the most of ServiceNow with solutions tailored to their unique needs. From implementation and customization to integrations and ongoing support, our experts simplify daily operations, automate repetitive tasks, and improve team productivity. We build scalable ServiceNow solutions that streamline processes, drive efficiency, and support long-term business growth and digital transformation. "} title={"ServiceNow Consulting"} />
            <ServiceNowConsultingSlider consultingData={consultingData} />
            <MaximizeModal wellbeingData={wellbeingData} />
            <IndustriesSliderSection industriesData={industriesData} />
            <ServiceNowBannerSection imgs={"/assets/mumbai/img3.png"} title="ServiceNow Consulting Services" text="At Mobikode, we help businesses in Bangalore make the most of ServiceNow through personalized consulting, smarter automation, and practical solutions that simplify work, improve efficiency, and support growth. " />
            <HireDeveloper /> */}
        </div>
    )
}

export default Bangalore
